<template>
  <v-app>
    <transition name="fadeToggle" mode="out-in">
      <router-view></router-view>
    </transition>

    <whats-new></whats-new>
  </v-app>
</template>

<script>
import WhatsNew from "@/components/central/whatsNew";
export default {
  name: "App",
  components: {
    WhatsNew
  }
};
</script>


<style>
/* .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  } */

.fadeToggle-enter-active,
.fadeToggle-leave-active {
  transition: opacity 0.2s;
}
.fadeToggle-enter,
.fadeToggle-leave-to {
  opacity: 0;
}

/* .fadeToggle-item {
    transition: all 0.2s;
    display: inline-block;
    width: 100%;
  }
  .fadeToggle-leave-active {
    position: absolute;
    transition: opacity .2s;
  }
  .fadeToggle-enter-active {
    transition: opacity .2s;
  }
  .fadeToggle-enter, .fadeToggle-leave-to {
    opacity: 0;
  } */

.flex-container-space-between {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.vertical-center-container {
  display: flex;
  align-items: center;
}

.pointer {
  cursor: pointer;
}
.w100 {
  width: 100%;
}

.card-divider {
  /* width: 100%; */
  height: 1px;
  margin: 10px 20px;
}

.card-footer {
  padding: 0px 16px 10px 16px;
}

.v-dialog {
  border-radius: 10px;
}

.v-dialog .v-card {
  border-radius: 10px;
}

.v-dialog--fullscreen {
  border-radius: 2px;
}
.v-dialog--fullscreen .v-card {
  border-radius: 2px;
}

.flex-container-end {
  display: flex;
  justify-content: flex-end;
}

.flex-container-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* LIST ANIMATIONS GENERIC */
.data-list-item {
  /* margin-right: 10px; */
  transition: all 0.4s;
  display: inline-block;
  width: 100%;
}

.field-list-item {
  transition: all 0.4s;
  display: inline-block;
  width: 100%;
  max-height: 100px;
}

.data-list-leave-active {
  position: absolute;
}

.field-list-leave-active {
  position: absolute;
  max-height: 0px;
}

/* LIST ANIMATIONS SPECIFIC MOVEMENT*/
.data-list-enter,
.data-list-leave-to {
  opacity: 0;
  transform: translateX(-200px);
}

.field-list-enter,
.field-list-leave-to {
  max-height: 0px;
  opacity: 0;
  transform: translateX(200px);
}

.truncate {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
}
</style>
